import { Component, Input } from '@angular/core';
import { MenuItem, MenuService } from '@trp/community/menu/data-access';
import { map } from 'rxjs';

@Component({
  selector: 'community-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent {
  @Input() pinned = false;

  menuDefinition$ = this.menuService.getMenu().pipe(
    map((def) => ({
      ...def,
      items: def.items.filter((item) => !!item.pinnedBottom === this.pinned),
    }))
  );

  constructor(private readonly menuService: MenuService) {}

  getSidebarLinkClass(item: MenuItem) {
    if (item.external) {
      return ['sidebar-link', 'external-link'];
    }

    return ['sidebar-link'];
  }

  isDisabled(item: MenuItem): boolean {
    return (
      (!!item.onlyVerified && !item.verified) ||
      (!!item.onlyCAA && !item.verified) ||
      (!!item.onlyCommunityManager && !item.communityManager)
    );
  }
}
